import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/connectChart",
    name: "connectCharts",
    component: () => import("../views/components/backStage/ConnectChart.vue"),
  },
  { path: "/login", name: "login", component: () => import("../views/Login.vue") },
  { path: "/controlPanel", name: "controlPanel", component: () => import("../views/ControlPanel.vue") },
  {
    path: "/",
    name: "aimadIntro",
    component: () => import("../views/backstage/aiMADIntro.vue"),
  },
  
  {
    path: "/detail/:id",
    name: "详情",
    component: () => import("../views/BackDetail.vue"),
    redirect: "/detail/:id/maindetail",
    children: [
      {
        path: "/detail/:id/maindetail",
        name: "详情",
        meta: { name: "MainDetail" },
        component: () => import("../views/components/detail/MainDetail.vue"),
      },
      {
        path: "/detail/:id/brand",
        name: "品牌",
        meta: { name: "Brand" },
        component: () => import("../views/components/detail/1brand/Brand.vue"),
      },
      {
        path: "/detail/:id/strategy",
        name: "战略",
        meta: { name: "Strategy" },
        component: () =>
          import("../views/components/detail/2strategy/Strategy.vue"),
      },
      {
        path: "/detail/:id/market",
        name: "市场",
        meta: { name: "Market" },
        component: () =>
          import("../views/components/detail/3market/Market.vue"),
      },
      {
        path: "/detail/:id/sales",
        name: "销售",
        meta: { name: "Sales" },
        component: () => import("../views/components/detail/4sales/Sales.vue"),
      },
      {
        path: "/detail/:id/purchase",
        name: "采购",
        meta: { name: "Purchase" },
        component: () =>
          import("../views/components/detail/5purchase/Purchase.vue"),
      },

      {
        path: "/detail/:id/product",
        name: "产品",
        meta: { name: "product" },
        component: () =>
          import("../views/components/detail/6product/Product.vue"),
      },

      {
        path: "/detail/:id/produce",
        name: "生产",
        meta: { name: "produce" },
        component: () =>
          import("../views/components/detail/7produce/Produce.vue"),
      },
      {
        path: "/detail/:id/craft",
        name: "工艺",
        meta: { name: "Craft" },
        component: () => import("../views/components/detail/8craft/Craft.vue"),
      },
      {
        path: "/detail/:id/quality",
        name: "质量",
        meta: { name: "Quality" },
        component: () =>
          import("../views/components/detail/9quality/Quality.vue"),
      },
      {
        path: "/detail/:id/research",
        name: "研发",
        meta: { name: "Research" },
        component: () =>
          import("../views/components/detail/10research/Research.vue"),
      },
      {
        path: "/detail/:id/logistics",
        name: "物流",
        meta: { name: "Logistics" },
        component: () =>
          import("../views/components/detail/11logistics/Logistics.vue"),
      },
      {
        path: "/detail/:id/staff",
        name: "人事",
        meta: { name: "Staff" },
        component: () => import("../views/components/detail/12staff/Staff.vue"),
      },
      {
        path: "/detail/:id/administration",
        name: "行政",
        meta: { name: "Administration" },
        component: () =>
          import(
            "../views/components/detail/13administration/Administration.vue"
          ),
      },

      {
        path: "/detail/:id/finance",
        name: "财务",
        meta: { name: "Finance" },
        component: () =>
          import("../views/components/detail/14finance/Finance.vue"),
      },
      {
        path: "/detail/:id/legal",
        name: "法务",
        meta: { name: "Legal" },
        component: () => import("../views/components/detail/15legal/Legal.vue"),
      },
    ],
  },
  
  {
    path: "/backstage",
    name: "首页",
    component: () =>
      import("../views/BackstageManager.vue"),
    redirect: "/backHome",
    children: [
      // 不同用户登录的主页面
      {
        path: "/brand",
        name: "品牌",
        meta: { name: "Brand" },
        component: () => import("../views/backstage/character/1Brand.vue"),
      },
      {
        path: "/strategy",
        name: "战略",
        meta: { name: "Strategy" },
        component: () => import("../views/backstage/character/2Strategy.vue"),
      },
      {
        path: "/market",
        name: "市场",
        meta: { name: "Market" },
        component: () => import("../views/backstage/character/3Market.vue"),
      },
      {
        path: "/sales",
        name: "销售",
        meta: { name: "Sales" },
        component: () => import("../views/backstage/character/4Sales.vue"),
      },
      {
        path: "/purchase",
        name: "采购",
        meta: { name: "Purchase" },
        component: () => import("../views/backstage/character/5Purchase.vue"),
      },
      {
        path: "/product",
        name: "产品",
        meta: { name: "Product" },
        component: () => import("../views/backstage/character/6Product.vue"),
      },
      {
        path: "/produce",
        name: "生产",
        meta: { name: "Produce" },
        component: () => import("../views/backstage/character/7Produce.vue"),
      },
      {
        path: "/craft",
        name: "工艺",
        meta: { name: "Craft" },
        component: () => import("../views/backstage/character/8Craft.vue"),
      },

      {
        path: "/quality",
        name: "质量",
        meta: { name: "Quality" },
        component: () => import("../views/backstage/character/9Quality.vue"),
      },
      {
        path: "/research",
        name: "研发",
        meta: { name: "Research" },
        component: () => import("../views/backstage/character/10Research.vue"),
      },
      {
        path: "/logistics",
        name: "物流",
        meta: { name: "Logistics" },
        component: () => import("../views/backstage/character/11Logistics.vue"),
      },
      {
        path: "/staff",
        name: "人事",
        meta: { name: "Staff" },
        component: () => import("../views/backstage/character/12Staff.vue"),
      },
      {
        path: "/administration",
        name: "行政",
        meta: { name: "Administration" },
        component: () =>
          import("../views/backstage/character/13Administration.vue"),
      },
      {
        path: "/finance",
        name: "财务",
        meta: { name: "Finance" },
        component: () => import("../views/backstage/character/14Finance.vue"),
      },
      {
        path: "/legal",
        name: "法务",
        meta: { name: "Legal" },
        component: () => import("../views/backstage/character/15Legal.vue"),
      },

      // 管理员页面
      {
        path: "/backHome",
        name: "概览",
        meta: { name: "BackHome" },
        component: () => import("../views/backstage/BackHome.vue"),
      },
      {
        path: "/backBU",
        name: "BU信息池",
        meta: { name: "BackBU" },
        component: () => import("../views/backstage/BackBU.vue"),
      },
      {
        path: "/adminGet",
        name: "获取",
        meta: { name: "AdminGet" },
        component: () => import("../views/backstage/admin/1AdminGet.vue"),
      },
      {
        path: "/adminInteraction",
        name: "交互",
        meta: { name: "AdminInteraction" },
        component: () =>
          import("../views/backstage/admin/2AdminInteraction.vue"),
      },
      {
        path: "/adminGenerate",
        name: "生成",
        meta: { name: "AdminGenerate" },
        component: () => import("../views/backstage/admin/3AdminGenerate.vue"),
      },
      {
        path: "/adminVerify",
        name: "验证",
        meta: { name: "AdminVerify" },
        component: () => import("../views/backstage/admin/4AdminVerify.vue"),
      },
      {
        path: "/backBUTask",
        name: "更新",
        meta: { name: "BackBUTask" },
        component: () => import("../views/backstage/BackBUTask.vue"),
      },
      {
        path: "/adminStatistics",
        name: "统计",
        meta: { name: "AdminStatistics" },
        component: () =>
          import("../views/backstage/admin/6AdminStatistics.vue"),
      },
      {
        path: "/adminReport",
        name: "报告",
        meta: { name: "AdminReport" },
        component: () => import("../views/backstage/admin/7AdminReport.vue"),
      },
      {
        path: "/dialogBox",
        name: "ChatBot",
        meta: { name: "DialogBox" },
        component: () =>
          import("@/views/components/backStage/chat/dialogBox.vue"),
      },
      {
        path: "/adminModification",
        name: "更改与录入",
        meta: { name: "AdminModification" },
        component: () =>
          import("../views/backstage/admin/9AdminModification.vue"),
      },
      {
        path: "/backBUKnowledgeBase",
        name: "储存",
        meta: { name: "BackBUKnowledgeBase" },
        component: () => import("../views/backstage/BackBUKnowledgeBase.vue"),
      },
      {
        path: "/backUser",
        name: "用户管理",
        meta: { name: "BackUser" },
        component: () => import("../views/backstage/BackBUUser.vue"),
      },


      /* {
        path: "/backBUBid",
        name: "招投标池",
        meta: { name: "BackBUBid" },
        component: () => import("../views/backstage/BackBUBid.vue"),
      }, */
      /* {
        path: "/backPoolTarget",
        name: "目标池",
        meta: { name: "BackPoolTarget" },
        component: () => import("../views/backstage/BackPoolTarget.vue"),
      },
      {
        path: "/backPoolMarket",
        name: "市场池",
        meta: { name: "BackPoolMarket" },
        component: () => import("../views/backstage/BackPoolMarket.vue"),
      },
      {
        path: "/backPoolInformation",
        name: "信息池",
        meta: { name: "BackPoolInformation" },
        component: () => import("../views/backstage/BackPoolInformation.vue"),
      },
      {
        path: "/backPoolProject",
        name: "项目池",
        meta: { name: "BackPoolProject" },
        component: () => import("../views/backstage/BackPoolProject.vue"),
      },
      {
        path: "/backPoolOrder",
        name: "订单池",
        meta: { name: "BackPoolOrder" },
        component: () => import("../views/backstage/BackPoolOrder.vue"),
      },
      {
        path: "/backPoolLoseBid",
        name: "丢单池",
        meta: { name: "BackLoseBid" },
        component: () => import("../views/backstage/BackPoolLoseBid.vue"),
      },
      {
        path: "/backPoolBU",
        name: "友商池",
        meta: { name: "BackPoolBU" },
        component: () => import("../views/backstage/BackPoolBU.vue"),
      },
      {
        path: "/backDebt",
        name: "资产负债表",
        meta: { name: "BackDebt" },
        component: () => import("../views/backstage/BackDebt.vue"),
      },
      {
        path: "/backProfit",
        name: "利润表",
        meta: { name: "BackProfit" },
        component: () => import("../views/backstage/BackProfit.vue"),
      },
      
      {
        path: "/BUAgent",
        name: "智能体",
        meta: { name: "BUAgent" },
        component: () => import("../views/backstage/BackBUAgent.vue"),
      },
      {
        path: "/backBUKnowledge",
        name: "知识库",
        meta: { name: "BackBUKnowledge" },
        component: () => import("../views/backstage/BackBUKnowledge.vue"),
      },
      
      {
        path: "/backBUEnvironment",
        name: "定时任务",
        meta: { name: "BackBUEnvironment" },
        component: () => import("../views/backstage/BackBUEnvironment.vue"),
      },
      {
        path: "/backLoseBill",
        name: "BackLoseBill",
        meta: { name: "BackLoseBill" },
        component: () => import("../views/backstage/BackLoseBill.vue"),
      },
      {
        path: "/backProduct",
        name: "产品池",
        meta: { name: "BackProduct" },
        component: () => import("../views/backstage/BackProduct.vue"),
      },
      {
        path: "/backBUEmail",
        name: "邮件池",
        meta: { name: "BackBUEmail" },
        component: () => import("../views/backstage/BackBUEmail.vue"),
      },
      {
        path: "/backBUFile",
        name: "文件池",
        meta: { name: "BackBUFile" },
        component: () => import("../views/backstage/BackBUFile.vue"),
      },
      
      {
        path: "/backGranularity",
        name: "颗粒度归属",
        meta: { name: "BackGranularity" },
        component: () => import("../views/backstage/BackGranularity.vue"),
      },
      
      {
        path: "/backBULog",
        name: "日志管理",
        meta: { name: "BackBULog" },
        component: () => import("../views/backstage/BackBULog.vue"),
      },
      {
        path: "/industryConnect",
        name: "行业关联",
        meta: { name: "IndustryConnect" },
        component: () => import("../views/backstage/IndustryConnect.vue"),
      }, */

      // {path: "/selfDetail",name: '信息修改', meta:{name:'SelfDetail'}, component: () => import('../views/backstage/BackSelfDetail.vue')},
      // {
      //     path: '/detail/:id',
      //     name: '详情',
      //     component: () => import('../views/backstage/BackDetail.vue'),
      //     meta: { hideContent: true }
      // },
      // {
      //     path: '/detail/:id',
      //     name: 'Detail',
      //     component: () => import('../views/backstage/BackDetail.vue')
      // },
    ],
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // }, 
  /* {
    path: "/data",
    name: "Manager",
    component: () =>
      import("../views/Manager.vue"),
    redirect: "/BU",
    children: [
      {
        path: "/overview",
        name: "Overview",
        meta: { name: "Overview" },
        component: () => import("../views/manager/Overview.vue"),
      },
      {
        path: "/BU",
        name: "BU",
        meta: { name: "BU" },
        component: () => import("../views/manager/BU.vue"),
      },
      // {
      //   path: "/market",
      //   name: "Market",
      //   meta: { name: "Market" },
      //   component: () => import("../views/manager/Market.vue"),
      // },
      {
        path: "/project",
        name: "Project",
        meta: { name: "Project" },
        component: () => import("../views/manager/Project.vue"),
      },
      {
        path: "/indent",
        name: "Indent",
        meta: { name: "Indent" },
        component: () => import("../views/manager/Indent.vue"),
      },
      {
        path: "/loseBill",
        name: "LoseBill",
        meta: { name: "LoseBill" },
        component: () => import("../views/manager/LoseBill.vue"),
      },
      {
        path: "/competitor",
        name: "Competitor",
        meta: { name: "Competitor" },
        component: () => import("../views/manager/Competitor.vue"),
      },
    ],
  }, */
  /* {
    path: "/test",
    name: "test",
    component: () => import("../views/manager/threesix1.vue"),
  }, */
 /*  {
    path: "/chart1",
    name: "chart1",
    meta: { name: "数据统计" },
    component: () => import("../views/Chart1.vue"),
  }, */
  /* {
    path: "/chat",
    name: "智能体",
    component: () =>
      import( "../views/ChatManager.vue"),
    redirect: "/dialogBox",
    children: [
      {
        path: "/dialogBox",
        name: "对话",
        meta: { name: "DialogBox" },
        component: () => import("../views/chat/dialogBox.vue"),
      },
      {
        path: "/aiAgent",
        name: "知识库智能体",
        meta: { name: "AiAgent" },
        component: () => import("../views/chat/aiAgent.vue"),
      },
      {
        path: "/aiAgentEmail",
        name: "邮件智能体",
        meta: { name: "AiAgentEmail" },
        component: () => import("../views/chat/aiAgentEmail.vue"),
      },
      {
        path: "/aiAgent2",
        name: "AiAgent2",
        meta: { name: "AiAgent2" },
        component: () => import("../views/chat/aiAgent2.vue"),
      },
    ],
  }, */
  // {
  //     path: '/detailManage',
  //     name: '详情',
  //     component: () => import(/* webpackChunkName: "manager" */ '../views/ChatManager.vue'),
  //     redirect: '/detail/:id',
  //     children: [
  //         {
  //             path: '/detail/:id',
  //             name: 'Detail',
  //             component: () => import('../views/backstage/BackDetail.vue')
  //         },
  //     ]
  // },
  
  
 /*  {
    path: "/table",
    name: "table",
    component: () => import("../views/components/detail/tools/simpleTable.vue"),
  }, */
/*   {
    path: "/doubletable",
    name: "doubletable",
    component: () => import("../views/components/detail/tools/doubleHeadTable.vue"),
  }, */
  

  // { path: '/table', name: 'table', component: () => import( '../views/backstage/TableDemo.vue')},
  /* {
    path: "/editDetail/:id",
    name: "修改详情",
    component: () => import("../views/detail/BackSelfDetail.vue"),
    redirect: "/editDetail/:id/maindetail",
    children: [
      {
        path: "/editDetail/:id/maindetail",
        name: "详情",
        meta: { name: "TempDetail" },
        component: () =>
          import("../views/detail/selfdetail/TempDetailEdit.vue"),
      },
      {
        path: "/editDetail/:id/brand",
        name: "品牌",
        meta: { name: "Brand" },
        component: () => import("../views/detail/selfdetail/1brand/Brand.vue"),
      },
      {
        path: "/editDetail/:id/strategy",
        name: "战略",
        meta: { name: "Strategy" },
        component: () =>
          import("../views/detail/selfdetail/2strategy/Strategy.vue"),
      },
      {
        path: "/editDetail/:id/market",
        name: "市场",
        meta: { name: "Market" },
        component: () =>
          import("../views/detail/selfdetail/3market/Market.vue"),
      },
      {
        path: "/editDetail/:id/sales",
        name: "销售",
        meta: { name: "Sales" },
        component: () => import("../views/detail/selfdetail/4sales/Sales.vue"),
      },
      {
        path: "/editDetail/:id/purchase",
        name: "采购",
        meta: { name: "Purchase" },
        component: () =>
          import("../views/detail/selfdetail/5purchase/Purchase.vue"),
      },

      {
        path: "/editDetail/:id/product",
        name: "产品",
        meta: { name: "product" },
        component: () =>
          import("../views/detail/selfdetail/6product/Product.vue"),
      },

      {
        path: "/editDetail/:id/produce",
        name: "生产",
        meta: { name: "produce" },
        component: () =>
          import("../views/detail/selfdetail/7produce/Produce.vue"),
      },
      {
        path: "/editDetail/:id/craft",
        name: "工艺",
        meta: { name: "Craft" },
        component: () => import("../views/detail/selfdetail/8craft/Craft.vue"),
      },
      {
        path: "/editDetail/:id/quality",
        name: "质量",
        meta: { name: "Quality" },
        component: () =>
          import("../views/detail/selfdetail/9quality/Quality.vue"),
      },
      {
        path: "/editDetail/:id/research",
        name: "研发",
        meta: { name: "Research" },
        component: () =>
          import("../views/detail/selfdetail/10research/Research.vue"),
      },
      {
        path: "/editDetail/:id/logistics",
        name: "物流",
        meta: { name: "Logistics" },
        component: () =>
          import("../views/detail/selfdetail/11logistics/Logistics.vue"),
      },
      {
        path: "/editDetail/:id/staff",
        name: "人事",
        meta: { name: "Staff" },
        component: () => import("../views/detail/selfdetail/12staff/Staff.vue"),
      },
      {
        path: "/editDetail/:id/administration",
        name: "行政",
        meta: { name: "Administration" },
        component: () =>
          import(
            "../views/detail/selfdetail/13administration/Administration.vue"
          ),
      },

      {
        path: "/editDetail/:id/finance",
        name: "财务",
        meta: { name: "Finance" },
        component: () =>
          import("../views/detail/selfdetail/14finance/Finance.vue"),
      },
      {
        path: "/editDetail/:id/legal",
        name: "法务",
        meta: { name: "Legal" },
        component: () => import("../views/detail/selfdetail/15legal/Legal.vue"),
      },
    ],
  }, */
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const whiteList = ["login", "aimadIntro"]; 

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("loginResponse");

  // 如果目标页面在白名单内，或者用户已登录，则放行
  if (whiteList.includes(to.name) || isAuthenticated) {
    next();
  } else {
    // 否则跳转到登录页
    next({ name: "login" });
  }
});

export default router;
